export const RESOLUTION_ENGINE_SERVICE = {
  afterSalesPlatform: 'ASP',
  backRepair: 'BACKREPAIR',
}
